import { IonCard, IonCardHeader, IonCardTitle, IonCardContent, IonIcon, IonButton } from '@ionic/react';
import { openOutline } from 'ionicons/icons';
import type { PublicPost } from '@ai-media/shared';
import { asArray } from '@/lib/collections';
import StatusPill from './StatusPill';
import PlatformChip from './PlatformChip';

export default function PostCard({ post }: { post: PublicPost }) {
  const platformIds = asArray(post.platform_ids);
  const mediaUrls = asArray(post.media_urls);
  const targets = asArray(post.targets);

  return (
    <IonCard className="post-card">
      <IonCardHeader style={{ paddingBottom: 4 }}>
        <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', alignItems: 'center' }} className="post-card__header-row">
          <StatusPill status={post.status} />
          {platformIds.map((id) => (
            <PlatformChip key={id} platform={id} />
          ))}
        </div>
        <IonCardTitle style={{ fontSize: '1.02rem', marginTop: 8 }}>
          {post.title ?? post.draft?.slice(0, 60)}
        </IonCardTitle>
      </IonCardHeader>
      <IonCardContent>
        <p className="post-excerpt">{post.content ?? post.draft}</p>
        {mediaUrls.length > 0 && (
          <div className="post-media">
            {mediaUrls.slice(0, 4).map((url) => (
              <img key={url} src={url} alt="" loading="lazy" />
            ))}
          </div>
        )}
        <div className="post-card__footer">
          <small style={{ color: 'var(--ion-color-medium)' }}>
            {post.published_at
              ? new Date(post.published_at).toLocaleString()
              : post.publish_at
                ? new Date(post.publish_at).toLocaleString()
                : '—'}
          </small>
          {targets
            .filter((target) => target?.permalink)
            .slice(0, 1)
            .map((target) => (
              <IonButton
                key={target.platform_id}
                size="small"
                fill="clear"
                href={target.permalink ?? undefined}
                target="_blank"
              >
                <IonIcon slot="end" icon={openOutline} />
              </IonButton>
            ))}
        </div>
      </IonCardContent>
    </IonCard>
  );
}
